// @flow

import { today, isLaterOrSame, toDate } from './date';

import type { AbstractCatalog } from 'modules/abstract-catalog';

export const isLive = ({ archived, dates }: AbstractCatalog): boolean => {
  const { last_live: lastLive } = dates;
  if (!lastLive) return true;
  return !archived && isLaterOrSame(toDate(lastLive), today());
};
